/**
 * smoothScrollTo — Premium custom scroll with easing
 *
 * @param {string} sectionId   - The element id to scroll to
 * @param {number} navOffset   - Pixels to subtract for fixed navbar (default 85)
 * @param {number} duration    - Scroll duration in ms (default 1100)
 */

// Expo ease-out: starts fast, gently glides to stop (cinematic feel)
function easeOutExpo(t) {
  return t === 1 ? 1 : 1 - Math.pow(2, -10 * t);
}

export function smoothScrollTo(sectionId, navOffset = 85, duration = 1100) {
  const target = document.getElementById(sectionId);
  if (!target) return;

  const startY    = window.scrollY;
  const targetY   = target.getBoundingClientRect().top + startY - navOffset;
  const distance  = targetY - startY;
  let startTime   = null;

  // If already there, bail
  if (Math.abs(distance) < 2) return;

  // Shorten duration slightly for small distances so it never feels laggy
  const adaptiveDuration = Math.min(duration, Math.max(600, Math.abs(distance) * 0.4));

  function step(timestamp) {
    if (!startTime) startTime = timestamp;
    const elapsed  = timestamp - startTime;
    const progress = Math.min(elapsed / adaptiveDuration, 1);
    const ease     = easeOutExpo(progress);

    window.scrollTo(0, startY + distance * ease);

    if (progress < 1) {
      requestAnimationFrame(step);
    }
  }

  requestAnimationFrame(step);
}
